import React, { useEffect, useState } from "react";
import axios from "axios";
import { ChevronDown, ChevronUp, History } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { OperationRow } from "../dashboard/RecentOperations";

const VISIBLE = 5;

export const SupplierRecentOps = ({ api }) => {
  const [items, setItems] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("session_token");
    axios.get(`${api}/dashboard/recent-operations`, { params: { session_token: token, kind: "supplier", limit: 50 } })
      .then((r) => setItems(r.data.items || [])).catch((e) => console.error("Tedarikçi işlemleri alınamadı:", e));
  }, [api]);

  const shown = expanded ? items : items.slice(0, VISIBLE);
  return (
    <Card data-testid="supplier-recent-ops">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base"><History className="h-5 w-5" /> Son Tedarikçi İşlemleri</CardTitle>
      </CardHeader>
      <CardContent>
        {shown.map((item) => <OperationRow key={`${item.kind}-${item.id}`} item={item} />)}
        {items.length === 0 && <p className="text-sm text-gray-500 py-4 text-center" data-testid="supplier-recent-ops-empty">İşlem bulunamadı</p>}
        {items.length > VISIBLE && (
          <div className="flex justify-center mt-2">
            <Button variant="outline" size="sm" onClick={() => setExpanded(!expanded)} data-testid="supplier-recent-ops-toggle">
              {expanded ? <><ChevronUp className="h-4 w-4 mr-1" /> Daha az göster</> : <><ChevronDown className="h-4 w-4 mr-1" /> Daha fazlasını görüntüle ({items.length - VISIBLE})</>}
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
